/**
 * Prepares an SVG element for themeability, scaling, and accessibility when injected into the DOM.
 * Ensures a `viewBox` exists, removes fixed dimensions, sets `aria-hidden="true"`,
 * and replaces non-none `fill` and `stroke` attributes with `currentColor`.
 */
export const injectThemeableIcon = (svg: SVGSVGElement): void => {
  const width = svg.getAttribute("width");
  const height = svg.getAttribute("height");

  if (!svg.getAttribute("viewBox") && width && height) {
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  }

  svg.removeAttribute("width");
  svg.removeAttribute("height");
  svg.setAttribute("aria-hidden", "true");

  svg.querySelectorAll<SVGElement>("*").forEach((element) => {
    const fill = element.getAttribute("fill");
    if (fill && fill !== "none") {
      element.setAttribute("fill", "currentColor");
    }

    const stroke = element.getAttribute("stroke");
    if (stroke && stroke !== "none") {
      element.setAttribute("stroke", "currentColor");
    }
  });
};
